import * as React from "react"

const SvgComponent = (props) => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="8" y="33.5" width="30" height="6" rx="3" fill="#557CFF"/>
        <rect x="9" y="26.5" width="28" height="6" rx="3" fill="#557CFF"/>
        <rect x="11" y="19.5" width="30" height="6" rx="3" fill="#557CFF"/>
        <rect x="12" y="12.5" width="26" height="6" rx="3" fill="#557CFF"/>
        <path d="M13.5879 8.60254C13.9955 8.21329 14.6667 8.29623 14.9668 8.77344L15.0244 8.88184L18.8457 17.2256C19.1184 17.8216 18.6828 18.4999 18.0273 18.5H15.9111L11.8037 39.2744C11.7204 39.6959 11.3505 39.9998 10.9209 40H6.06641C5.49941 40 5.07291 39.482 5.18262 38.9258L9.22168 18.5H7.51367C6.75877 18.4998 6.33944 17.6261 6.81152 17.0371L13.5049 8.69336L13.5879 8.60254Z" fill="#557CFF" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);
export default SvgComponent